import { observer } from 'mobx-react-lite'
import { JobManagementDialogsContainer } from '@/features/jobs/list/components/JobManagement/JobManagementDialogsContainer'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { JobsViewerHeaderContainer } from '@/features/jobs/list/components/JobManagement/JobsViewerHeader/JobsViewerHeaderContainer'
import { JobsTableContainer } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableContainer'
import { UpcomingConsultationPreviewContainer } from '@/features/jobs/list/components/UpcomingConsultationPreview/UpcomingConsultationPreviewContainer'
import {
  JobsViewer,
  JobsViewerTitle,
} from '@/features/jobs/list/components/JobManagement/JobsViewer'
import { JobCountContainer } from '@/features/jobs/list/components/JobManagement/JobCountContainer'

export interface JobsViewerContainerProps {
  vm: JobManagementViewModel
}

export const JobsViewerContainer = observer(function JobsViewerContainer({
  vm,
}: JobsViewerContainerProps) {
  return (
    <JobsViewer
      consultationPreview={
        <UpcomingConsultationPreviewContainer
          vm={vm.upcomingConsultationPreviewVm}
        />
      }
      title={<JobsViewerTitle count={<JobCountContainer vm={vm} />} />}
      header={<JobsViewerHeaderContainer vm={vm} />}
    >
      <JobsTableContainer vm={vm} />
      <JobManagementDialogsContainer vm={vm} />
    </JobsViewer>
  )
})
